export default __webpack_public_path__ + "static/ak-cached/24h/media/black-friday-flash-sale-dropdown-closed.1598180d.jpg";